import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadSubSourceService {

  constructor(private ws: PostmethodService) { }

  subSourceCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "leadSubSourceMaster");
  }

  sourceList(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "leadSourceMaster");
  }
}
